export default {
  namespaced: true,
  state: {
    token: null,
  },
  actions: {
    async setToken({ commit }, { token }) {
      commit('setToken', { token });
    },
  },
  mutations: {
    setToken(state, { token }) {
      state.token = token;
    },
  },
  getters: {
    token(state) {
      return state.token;
    },
  },
};
